import React, { useEffect, useRef, useState } from 'react'
import { Button } from '../global/Button'
import { Share } from '../global/Share'
import { Line } from '../global/Line'
import Typed from 'typed.js'
import introImg from "../../images/hackathon/globe-with-tags.svg"

export const AltIntro = () => {
  const labelRef = useRef(null)
  const textBlock = useRef(null)
  const [line, setLine] = useState(null)

  // Hardcoded Content
  const content = {
    titlePart1: "Rootstock",
    titlePart2: "Hacker",
    supText1: "Static & Fast",
    titlePart3: "HUB",
    number: "01",
    text: "Join a vibrant community of developers accelerating Bitcoin's functionality through Rootstock.",
    link: {
      title: "Join Hackathon",
      url: "#events-carousel"
    }
  }

  const typedOptions = {
    showCursor: false,
    typeSpeed: 30
  }

  let typed = [
    { text: content.titlePart1, suptext: useRef(null), ref: useRef(null), typed: useRef(null) },
    { text: content.titlePart2, ref: useRef(null), suptext: useRef(null), typed: useRef(null) },
    { text: content.titlePart3, ref: useRef(null), typed: useRef(null) }
  ]

  const LineX = () => <Line start={typed[1].ref} color={'#fff'} end={labelRef} animateDrawing={0} />

  useEffect(() => {
    let nextWordDelay = 0

    typed.forEach((item, index) => {
      if (index !== 0) {
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay: nextWordDelay,
        strings: [item.text],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('opacity-0')
          if (item.suptext?.current) {
            item.suptext.current.classList.remove('opacity-0')
          }
        },
        onComplete: (self) => {
          if (index === typed.length - 1) {
            setLine(<LineX />)
            textBlock.current.classList.remove('opacity-0')
            document.querySelector('.zg-hackathon-intro-img')?.classList.remove('opacity-0')
          }
        }
      })
    })

    return () => {
      typed.forEach((item) => item.typed.current.destroy())
    }
  }, [])

  return (
    <section className="pt-14-rem pb-md-11 pb-11 pb-lg-7 intro intro-content" id="dev-intro">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-9 col-lg-10 col-xl-8 position-relative">
            <h1 className="mb-5 mb-md-6 mb-lg-7 d-inline-flex h2 flex-wrap align-items-start intro-title">
              <span className="zg-text-bg bg-pink mb-1 me-1 me-md-2 mb-md-2 opacity-0" ref={typed[0].ref}></span>
              <span className="zg-text-bg bg-white mb-1 me-1 me-md-2 mb-md-2 opacity-0" ref={typed[1].ref}></span>
              <span className="zg-text-bg bg-green me-1 me-md-2 mb-1 mb-md-2 opacity-0" ref={typed[2].ref}></span>
            </h1>
            <img 
              src={introImg} 
              className="zg-hackathon-intro-img transition-opacity opacity-0" 
              alt="Globe" 
              width="408" 
              height="392" 
              loading="lazy" 
            />
          </div>
        </div>
        <div className="row opacity-0 transition-opacity" ref={textBlock}>
          <div className="col-12 col-md-6 col-xl-5 offset-xl-1 pb-12 pb-md-0">
            <Share />
          </div>
          <div className="col-md-6 col-xl-4 offset-xl-2 col-12 mt-md-n2 mt-xl-n6">
            <div className="d-flex gap-4 align-items-start">
              <span className="zg-label text-black bg-white mb-2" ref={labelRef}>{content.number}</span>
              <div>
                <p className="subtitle-md mb-3 mb-md-4">{content.text}</p>
                <Button title={content.link.title} url={content.link.url} classes="btn btn-outline-white" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {line}
    </section>
  )
}
